import { List, Map } from 'immutable';
import { DEFAULT_SESSION_ID } from '../constants';
import { notificationListActions } from './actions';
import { NotificationList } from './notification-list';

export const initialState = new Map({
  currentNotificationListId: DEFAULT_SESSION_ID,
  [DEFAULT_SESSION_ID]: new NotificationList({id: DEFAULT_SESSION_ID, isNew: false})
});

export function notificationListsReducer(state = initialState, action) {

  const { type, payload } = action;
  switch (type) {
    case notificationListActions.FETCH_NOTIFICATIONS_SUCCESS:
    case notificationListActions.FETCH_NOTIFICATIONS_PENDING:
      return state.set(
        payload.notificationListId,
        notificationListReducer(state.get(payload.notificationListId), action)
      );
    case notificationListActions.LOAD_NOTIFICATIONS:
      return state.merge({
        currentNotificationListId: payload.notificationListId,
        [payload.notificationListId]: notificationListReducer(state.get(payload.notificationListId), action)
      });
    default:
      return state;
  }
}

export const notificationListReducer = (state = new NotificationList() , { payload, type }  ) => {
  switch (type) {
    case notificationListActions.FETCH_NOTIFICATIONS_SUCCESS:
     return state.withMutations(notificationList => {
       notificationList
        .merge({
          isNew:false,
          isPending:false,
          notifiactionIds: mergeIds(notificationList.notifiactionIds, payload.data),           
       });
      });
    case notificationListActions.FETCH_NOTIFICATIONS_PENDING:
      return state.set('isPending', true);
    case notificationListActions.LOAD_NOTIFICATIONS:
      return state.withMutations(notificationList => {
        notificationList
          .merge({
            id: payload.notificationListId,
          });
        });
    default:
      return state;
  }
}

function mergeIds(notifiactionIds, items) {
  let ids = notifiactionIds.toJS();

  let newIds = items.reduce((list, notificationData) => {
    if (ids.indexOf(notificationData.id) === -1) list.push(notificationData.id);
    return list;
  }, []);
  return newIds.length ? new List(ids.concat(newIds)) : notifiactionIds;
}
